import LocaleSwitcherOutdoor from "./components/LocaleSwitcherOutdoor";

if (!window.customElements.get("arcteryx-locale-switcher")) {
  window.customElements.define("arcteryx-locale-switcher", LocaleSwitcherOutdoor);
}
